import { CreditCard, Landmark, Banknote } from "lucide-react";
import { PageHero, SectionHeading } from "../components/SectionHeading";
import { HowItWorksSteps } from "../components/HowItWorksSteps";
import { CtaBand } from "../components/CtaBand";
import { useBrand, useConfig } from "../context/BrandContext";
import { IMAGES } from "../data/content";

const PAY_ICONS = [CreditCard, Landmark, Banknote];

export default function HowItWorks() {
  const b = useBrand();
  const { statuses } = useConfig();
  return (
    <>
      <PageHero testid="how-hero" eyebrow="How it works" title="From registration to your driveway" image={IMAGES.doorToDoor}
        sub="One clear process for every vehicle and every load. You always know what happens next, and who to call." />
      <section className="py-20 md:py-28"><div className="container-x"><HowItWorksSteps full /></div></section>
      <section className="py-20 md:py-28 bg-white border-y border-slate-200" data-testid="how-payment">
        <div className="container-x grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <SectionHeading eyebrow="Payment" title="No upfront payment" sub={`${b.payment_note} Payments are handled directly by our financial department, never on this website.`} />
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
            {b.payment_methods.map((m, i) => {
              const I = PAY_ICONS[i] || CreditCard;
              return (
                <div key={m} className="panel p-6 bg-white" data-testid={`payment-method-${i}`}>
                  <I className="w-7 h-7 text-orange-600" strokeWidth={1.5} />
                  <div className="mt-5 font-display font-bold uppercase text-slate-900 text-lg leading-tight">{m}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <section className="py-20 md:py-28" data-testid="how-stages">
        <div className="container-x">
          <SectionHeading eyebrow="Tracking stages" title="Every milestone, visible" sub="Your tracking number shows exactly where your shipment stands." className="mb-12" />
          <ol className="flex flex-wrap gap-3">
            {statuses.map((s, i) => (
              <li key={s} className="flex items-center gap-3 panel px-4 py-3">
                <span className="font-mono text-xs text-orange-600">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-display uppercase tracking-wide font-semibold text-slate-900">{s}</span>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
